import React, { useContext } from 'react';
import { MdMenu } from 'react-icons/md';
import { NavContext } from '../../contexts/NavContext';
import { NavbarContainer, Icon, NavbarLi, NavbarUl, ContentContainer } from './navbar-styles';
import { Link } from 'react-router-dom';

const Navbar = () => {
	const { showSidebar, setShowSidebar } = useContext(NavContext);

	const handleClick = () => setShowSidebar(!showSidebar);

	return (
		<React.Fragment>
			<NavbarContainer>
				<Icon>
					<MdMenu onClick={handleClick} />
				</Icon>
				<ContentContainer>
					<Link to="/home" className="nav-company-logo">
						<h1>StayFit</h1>
					</Link>

					<NavbarUl>
						<NavbarLi>
							<Link to="/home">Home</Link>
						</NavbarLi>
						<NavbarLi>
							<Link to="/membership">Membership</Link>
						</NavbarLi>
						<NavbarLi>
							<Link to="/all-gear">Gear</Link>
						</NavbarLi>
						<NavbarLi>
							<Link to="/locations">Locations</Link>
						</NavbarLi>
						<NavbarLi>
							<Link to="/our-mission">Our Mission</Link>
						</NavbarLi>
					</NavbarUl>
				</ContentContainer>
			</NavbarContainer>
		</React.Fragment>
	);
};

export default Navbar;
